import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import { department } from "services/department-service";
import * as departmentService from "services/department-service";
import { useTranslation } from "react-i18next";

interface IProps {
    open: boolean;
    onClose: () => void;
    department: department;
    tenantId: string;
}

const DepartmentDeleteModal = (props: IProps) => {
    const { t } = useTranslation();
    const { open, onClose, department, tenantId } = props;
    const [departmentName, setDepartmentName] = React.useState<string>(
        department.name,
    );

    React.useEffect(() => {
        setDepartmentName(department.name);
    }, [department]);

    const handleUpdate = () => {
        departmentService.deleteDepartment(department.id, tenantId).then(() => {
            onClose();
        });
    };

    return (
        <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth={"sm"}>
            <DialogTitle>{t("departments.delete")}</DialogTitle>
            <DialogContent>
                <Box sx={{ paddingTop: "0.50rem", height: "fit-content" }}>
                    <p>{t("departments.deleteText")}</p>
                    <TextField
                        label={t("departments.name")}
                        value={departmentName}
                        onChange={(e) => setDepartmentName(e.target.value)}
                        fullWidth
                        size="small"
                        disabled
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="cancel"
                    onClick={() => onClose()}
                >
                    {t("buttons.cancel")}
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleUpdate}
                >
                    {t("buttons.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DepartmentDeleteModal;
